import api from './api';

const endpoint = '/api/v1/search';

export default {
    async get(term) {
        return await api.post(endpoint, {
            search: term,
        });
    },
}
